














import Vue from 'vue'
import ClientList from '@/components/client-work/client-list.vue'
import ClientModal, { Client } from '@/components/client-work/client-modal.vue'
import CategoryFilter, { Category } from '@/components/client-work/category-filter.vue'

const WP_SITE_URL = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_DEV_WP_SITE_URL : process.env.VUE_APP_PRO_WP_SITE_URL
let allClients: Client[] = []

export default Vue.extend({
  components: {
    ClientList,
    ClientModal,
    CategoryFilter
  },

  data() {
    return {
      clients: [] as Client[],
      categories: [] as Category[],
      activeClient: {} as Client
    }
  },

  async created() {
    allClients = this.shuffle(await this.fetchPosts())
    this.clients = allClients

    const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/categories?per_page=100`)
    this.categories = await response.json() as Category[]      

    const isPreview = this.$route.query.preview === 'true'
    if (isPreview) {
      this.activeClient = await this.fetchDraftPost(Number(this.$route.query.id))
    }
  },

  methods: {
    async fetchPosts(category?: number) {
      const query = new URLSearchParams({
        per_page: '50',
         _embed: '1',
        acf_format: 'standard'
      })

      if (category) {
        query.append('categories', category.toString())
      }

      const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/posts?${query}`)
      const posts = await response.json()
      return posts.map(post => this.formatClientData(post))
    },

    async fetchDraftPost(id: number) {
      const query = new URLSearchParams({
        status: 'draft',
        _embed: '1',
        acf_format: 'standard'
      })

      const response = await fetch(`${WP_SITE_URL}/wp-json/wp/v2/posts/${id}?${query}`, {
        headers: {
          'X-WP-Nonce': this.$route.query.nonce
        }
      })
      const post = await response.json()
      return this.formatClientData(post)
    },

    formatClientData(post) {
      const gallery = post.acf.gallery.map(item => ({ src: item.sizes.large, width: item.width, height: item.height, caption: item.caption  }))
      const projects = post.acf.project.map(item => ({ name: item.project_name, url: item.url }))
      const client: Client = {
        id: post.id,
        categories: post.categories,
        oneLetter: post.acf.one_letter,
        clientName: post.title.rendered,
        clientDescription: post.acf.client_description,
        clientSite: post.acf.client_site,
        gallery,
        projects,
        designSelectionAward: post.acf.design_selection_award
      }
      return client
    },

    async applyFilter(category: number) {
      if (category > -1) {
        this.clients = allClients.filter(client => client.categories.includes(category))
      } else {
        this.clients = allClients
      }
    },

    openModal(id: number) {
      this.activeClient = this.clients.find(client => client.id === id) as Client
    },

    closeModal() {
      this.activeClient = {} as Client
    },

    shuffle(clients: Client[]) {
      for (let i = clients.length - 1; i >= 0; i--) {
        const rand = Math.floor(Math.random() * (i + 1)) as number
        [clients[i], clients[rand]] = [clients[rand], clients[i]]
      }
      return clients
    }
  }
})
